import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-landing-vacation',
    templateUrl: './landing-vacation.component.html',
    styleUrls: ['./landing-vacation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LandingVacationComponent {}
